import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const HoppProConceptViablokk = () => {
  const features = [
    'Talajmechanikai vizsgálat után, megfelelő sávalapra telepítjük',
    'Gyors építési idő',
    'Családi háznak engedélyeztethető',
    'Választható külső borítás',
    'Belső nyílászárók',
    'Kiemelkedő műszaki tartalom',
    'Nagyon alacsony rezsi költség'
  ];

  const construction = [
    'Földmunka, alapozás, aljzatkészítés',
    'Szerelőbeton vízszigetelése és hőszigetelése, aljzatbetonozás',
    'Szerkezet készítés',
    'Tetőfedés',
    'Ereszcsatorna',
    'Külső hőszigetelés',
    'Álmenyezet',
    'Beltéri ajtók',
    'Épületgépészet',
    'Villanyszerelés',
    'Glettelés, festés-mázolás',
    'Burkolás',
    'Kültéri nyílászárók'
  ];

  return (
    <>
      <Helmet>
        <title>Viablokk Családi Ház | Hopp ProConcept | HoppHomes</title>
        <meta name="description" content="Szilárd falazatú VIABLOKK (YTONG) családi lakóépület. Gyors építési idő, kiemelkedő műszaki tartalom, alacsony rezsi költség." />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a] text-white">
        
        {/* Breadcrumb */}
        <div className="bg-[#23272f] border-b border-white/10">
          <div className="max-w-7xl mx-auto px-4 py-4">
            <div className="flex items-center gap-2 text-sm">
              <Link to="/" className="text-gray-400 hover:text-white transition-colors">Főoldal</Link>
              <span className="text-gray-600">/</span>
              <Link to="/hopp-proconcept" className="text-gray-400 hover:text-white transition-colors">Hopp ProConcept</Link>
              <span className="text-gray-600">/</span>
              <span className="text-white">Viablokk</span>
            </div>
          </div>
        </div>

        {/* Hero Section */}
        <section className="py-12 sm:py-16 px-4">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center">
              
              {/* Image */}
              <div className="aspect-video bg-gradient-to-br from-secondary/20 to-transparent rounded-2xl overflow-hidden border border-white/10">
                <img 
                  src="/dvb-viablokk.jpg"
                  alt="Viablokk családi ház"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Info */}
              <div>
                <div className="inline-block bg-secondary/20 backdrop-blur-sm border border-secondary/30 rounded-full px-4 py-2 mb-4">
                  <span className="text-secondary font-semibold text-sm">Szilárd Falazat</span>
                </div>
                <h1 className="text-4xl md:text-5xl font-bold mb-6">
                  VIABLOKK Családi Ház
                </h1>
                <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                  Szilárd falazatú VIABLOKK (YTONG) családi lakóépület
                </p>

                {/* CTA Buttons */}
                <div className="flex flex-col gap-3 sm:gap-4">
                  <a 
                    href="tel:+36304130001"
                    className="bg-secondary hover:bg-hover active:bg-hover text-white font-bold px-6 sm:px-8 py-4 sm:py-5 rounded-lg transition-all duration-200 text-center text-base sm:text-lg touch-manipulation"
                  >
                    📞 Ajánlatkérés
                  </a>
                  <a 
                    href="mailto:hoppxplatform@gmail.com"
                    className="bg-white/10 hover:bg-white/20 active:bg-white/30 text-white font-bold px-6 sm:px-8 py-4 sm:py-5 rounded-lg transition-all duration-200 text-center border border-white/[0.08] text-base sm:text-lg touch-manipulation"
                  >
                    ✉️ Email küldése
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="py-16 px-4 bg-[#18181b]">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl font-bold mb-8">Főbb jellemzők</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
              {features.map((feature, index) => (
                <div 
                  key={index}
                  className="bg-[#23272f] border border-white/10 rounded-lg p-4 flex items-start gap-3"
                >
                  <div className="text-2xl text-secondary flex-shrink-0">✓</div>
                  <span className="text-gray-300">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Description Section */}
        <section className="py-16 px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold mb-6">Miért válassza a Viablokk technológiát?</h2>
            <div className="space-y-4 text-gray-300 leading-relaxed">
              <p>
                Napjainkban egyre többen döntenek amellett, hogy nem egy régi épület felújításába vágnak bele, hanem inkább jövőbe mutató, modern technológiák segítségével építtetik meg álmaik otthonát.
              </p>
              <p>
                A modern anyagok és gépészeti megoldások használata elősegíti, hogy a rezsi költségek sokkal alacsonyabbak legyenek elődeiknél. Nem beszélve arról, hogy a régi épületek java része nagyon sokszor nem megfelelő alapra került, így a felújítás okozta terhelés komoly, sokszor életveszélyes hibákat fedhet fel.
              </p>
              <p>
                Például a nem megfelelően elkészített alap és szigetelés, illetve elkorrodált vízvezetékek és gáz csövek, amik a költségvetést nem várt módon, gyakran sok millió forintos váratlan költséggel terheli meg.
              </p>
              <div className="bg-secondary/10 border border-secondary/30 rounded-lg p-6 mt-6">
                <p className="font-bold text-white mb-2">
                  💡 Ha szeretné Ön is elkerülni ezeket a problémákat, mindenképpen érdemes az újonnan történő építést választania.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Construction Section */}
        <section className="py-16 px-4 bg-[#18181b]">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl font-bold mb-8">Kivitelezés</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
              {construction.map((item, index) => (
                <div 
                  key={index}
                  className="bg-[#23272f] border border-white/10 rounded-lg p-4 flex items-center gap-3"
                >
                  <div className="w-8 h-8 rounded-full bg-secondary/20 flex items-center justify-center text-secondary font-bold flex-shrink-0">
                    {index + 1}
                  </div>
                  <span className="text-gray-300">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Details Section */}
        <section className="py-16 px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold mb-6">Részletek</h2>
            <div className="bg-[#23272f] border border-white/10 rounded-xl p-8">
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <span className="text-2xl">📄</span>
                  <div>
                    <h3 className="font-bold text-lg mb-2">Kivitelezési munkálatok</h3>
                    <p className="text-gray-400 text-sm mb-4">
                      Részletes leírás a kivitelezési munkálatokról PDF formátumban.
                    </p>
                    <a 
                      href="https://dvbwoods.hu/assets/viablokk.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block bg-secondary hover:bg-hover text-white font-bold px-6 py-3 rounded-lg transition-all duration-200"
                    >
                      📥 Letöltés (PDF)
                    </a>
                  </div>
                </div>

                <div className="border-t border-white/10 pt-4 mt-4">
                  <p className="text-sm text-gray-400">
                    ⚠️ Áraink tájékoztató jellegűek! Minden kivitelezés illetve szerződéskötés előtt pontos adatok függvényében tudunk teljes árajánlatot adni.
                  </p>
                  <p className="text-sm text-gray-400 mt-2">
                    ⏰ Árajánlataink 30 napig érvényesek!
                  </p>
                  <p className="text-sm text-gray-400 mt-2">
                    💰 Áraink bruttóban értendők.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Other Models */}
        <section className="py-16 px-4 bg-[#18181b]">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl font-bold mb-8 text-center">További Hopp ProConcept házak</h2>
            <div className="grid md:grid-cols-4 gap-6">
              {['venezia', 'genova', 'verona', 'siena'].map((model) => (
                <Link
                  key={model}
                  to={`/hopp-proconcept/${model}`}
                  className="group bg-[#23272f] border border-white/10 rounded-xl overflow-hidden hover:border-secondary/50 transition-all duration-300"
                >
                  <div className="aspect-video bg-gradient-to-br from-secondary/20 to-transparent overflow-hidden">
                    <img 
                      src={`/dvb-${model}.jpg`}
                      alt={model.charAt(0).toUpperCase() + model.slice(1)}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-4">
                    <h3 className="text-lg font-bold group-hover:text-secondary transition-colors capitalize">
                      {model}
                    </h3>
                  </div>
                </Link>
              ))}
            </div>
            <div className="text-center mt-8">
              <Link 
                to="/hopp-proconcept"
                className="inline-block bg-secondary hover:bg-hover text-white font-bold px-8 py-3 rounded-lg transition-all duration-200"
              >
                Összes Hopp ProConcept termék
              </Link>
            </div>
          </div>
        </section>

        {/* Contact CTA */}
        <section className="py-16 px-4">
          <div className="max-w-4xl mx-auto bg-gradient-to-r from-secondary/20 to-transparent border border-secondary/30 rounded-2xl p-8 text-center">
            <div className="mb-6">
              <div className="inline-block bg-[#161616] backdrop-blur-sm border border-white/[0.08] rounded-full px-4 py-2 mb-4">
                <span className="text-sm font-semibold">🏗️ HoppHomes Saját Termék</span>
              </div>
            </div>
            <h2 className="text-3xl font-bold mb-4">
              Kérdése van a Viablokk technológiáról?
            </h2>
            <p className="text-xl text-gray-300 mb-6">
              Szakértő csapatunk segít minden részletben! Hopp ProConcept termékek teljes körű tanácsadással.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="tel:+36304130001"
                className="bg-secondary hover:bg-hover text-white font-bold px-8 py-4 rounded-lg transition-all duration-200"
              >
                📞 +36 30 413 0001
              </a>
              <a 
                href="mailto:hoppxplatform@gmail.com"
                className="bg-white/10 hover:bg-white/20 text-white font-bold px-8 py-4 rounded-lg transition-all duration-200 border border-white/[0.08]"
              >
                ✉️ hoppxplatform@gmail.com
              </a>
            </div>
          </div>
        </section>

      </div>
    </>
  );
};

export default HoppProConceptViablokk;
